import api from '.'
import { SmicSchema } from '../../../backend/src/services/providers/insee/smic.model'

export const get = async (date: Date): Promise<SmicSchema | undefined> => {
  return await api({
    endpoint: `/smic`,
    method: 'GET',
    params: {
      date,
    },
  })
}
